import React from 'react';
import blockStyles from '@baseStyles/block.scss';
import styles from './ContentD4.scss';
import 'swiper/css/pagination';
import ContentB1 from "@components/blocks/ContentB1/ContentB1";
import Button from "@components/base/Button/Button";
import useDataFileAction from "@hooks/useDataFileAction";

const ContentD4 = ({data}) => {
	if (!data) {
		return null;
	}

	const isValidData = Array.isArray(data.blockContent) && data.blockContent.every(item => item.title && item.desc);

	if (isValidData === false) {
		return null;
	}

	const {executeAction, ModalPortal} = useDataFileAction();

	return (
	  <>
		  <div className={blockStyles.baseContainerHolder}>
			  <ContentB1 title={data.blockTitle} desc={data.blockDesc} size={'M'}/>
		  </div>

		  <div className={styles.container}>
			  <div className={styles.bannersHolder}>
				  {data.blockContent.map((val, key) => (
					<div className={`${styles.banner} ${val.page ? styles[val.page] : ''}`} key={key}>
						{/* Title */}
						<div className={styles.title} dangerouslySetInnerHTML={{__html: val.title}}/>

						{/* Logo */}
						<div className={styles.logo}></div>

						{/* Content */}
						<div className={styles.content}>
							<h3>{val.subTitle}</h3>
							<p dangerouslySetInnerHTML={{__html: val.desc}}/>

							<div className={blockStyles.mtAuto}>
								{val.buttonText &&
								  <Button
									value={val.buttonText}
									onClick={() => executeAction(val)}
								  />
								}
							</div>
						</div>
					</div>
				  ))}
			  </div>

			  {/* Render modal with portal (in html.php container - <div id="modalContainer"></div>) */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {ModalPortal}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  </div>
	  </>
	)
}

export default ContentD4;
